export default __webpack_public_path__ + "static/media/galerie2.0bb991a4.jpg";